import { Container, Grid, Paper, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';

const OurDoctors = () => {
    const [doctors, setDoctors] = useState([]);

    useEffect(() => {
        fetch('https://rocky-reef-13015.herokuapp.com/doctors')
            .then(res => res.json())
            .then(data => setDoctors(data))
    }, [])

    
    return (
        <Container>
            <Typography sx={{ pt: 10, pb: 4, fontWeight: 600, color: "#5CE7ED" }} variant="h6">
                OUR DOCTORS
            </Typography>
            <Grid container spacing={2} sx={{ mb: 4 }}>
                {
                    doctors.map(doctor => <Grid key={doctor._id} item xs={12} sm={6} md={4}>
                        <Paper elevation={3} sx={{ py: 5, border: 0, boxShadow: 0 }}>
                            <img style={{ width: "80%" }} src={`data:image/png;base64,${doctor.image}`} alt="" />
                            <Typography variant="body1" color="text.primary" sx={{ py: 0.5 }}>
                                <b>{doctor.name}</b>
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                <b>{doctor.email}</b>
                            </Typography>
                        </Paper>
                    </Grid>)
                }
            </Grid>
        </Container>
    );
};

export default OurDoctors;